module.exports = __webpack_public_path__ + "static/media/administration-access.2f764050.svg";